import { EmployeeIdpResult, EmployeeIdpStatus, EmployeeIdpType, IdpPdfLanguage } from '@/common/graphql';

export const EmployeeIdpTypeLabels: Record<EmployeeIdpType, string> = {
  [EmployeeIdpType.Idp]: 'IDP',
  [EmployeeIdpType.IdpLite]: 'IDP Lite',
};

export const EmployeeIdpStatusLabels: Record<EmployeeIdpStatus, string> = {
  [EmployeeIdpStatus.Draft]: 'Draft',
  [EmployeeIdpStatus.Reviewing]: 'Reviewing',
  [EmployeeIdpStatus.OverdueReviewing]: 'Reviewing [Overdue]',
  [EmployeeIdpStatus.OverdueResult]: 'Awaiting Result [Overdue]',
  [EmployeeIdpStatus.CompletedSuccess]: 'Completed - Success',
  [EmployeeIdpStatus.CompletedFailure]: 'Completed - Failure',
  [EmployeeIdpStatus.Cancelled]: 'Cancelled',
};

export const EmployeeIdpResultLabels: Record<EmployeeIdpResult, { name: string; description: string }> = {
  [EmployeeIdpResult.SuccessfulCompletion]: { name: 'Successful completion', description: 'Resume normal duties' },
  [EmployeeIdpResult.Failure]: {
    name: 'Failure',
    description: "Grading D in upcoming performance review & follow all grading D's implications",
  },
};

export const IDP_OCCURRENCE_COUNT: Record<EmployeeIdpType, number> = {
  [EmployeeIdpType.Idp]: 8,
  [EmployeeIdpType.IdpLite]: 6,
};

// 061-idp-pdf-signing FR-004: the PDF generation dialog's document-language options.
export const IdpPdfLanguageLabels: Record<IdpPdfLanguage, string> = {
  [IdpPdfLanguage.En]: 'English',
  [IdpPdfLanguage.Ja]: 'Japanese',
  [IdpPdfLanguage.Th]: 'Thai',
  [IdpPdfLanguage.Vi]: 'Vietnamese',
  [IdpPdfLanguage.ZhHant]: 'Chinese (Traditional)',
  [IdpPdfLanguage.ZhHans]: 'Chinese (Simplified)',
  [IdpPdfLanguage.Ko]: 'Korean',
  [IdpPdfLanguage.Km]: 'Khmer',
};
